import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { chartImageScaleFactor } from "../../../constants";
import exportCharts from "../../multipleChartExporting";
import ChangeByGniGroupChart from "./ChangeByGniGroupChart";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";

const ChangeByGniGroupChartWidget = props => {
  const [methodId, setMethodId] = useState();

  const chartRefs = {};

  return (
    <DataViewerFrame
      dataViewerId="change_by_gni_group_chart"
      reference={props.reference}
      title={props.title}
      subtitle={props.subtitle}
      contentWidth={400}
      filters={[
        <MethodChooser
          id={props.chooserId}
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: `theme5.${props.id}`,
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          method: methodId ? props.database.methods[methodId] : "All"
        });
      }}
      onDownloadPng={() => {
        exportCharts(chartRefs, {
          filename: "change_by_gni_group_chart",
          scale: chartImageScaleFactor
        });
      }}
    >
      <ChangeByGniGroupChart
        data={props.data}
        yAxisTitle={props.yAxisTitle}
        tooltipFormatter={props.tooltipFormatter}
        onRegisterChartRef={(key, ref) => {
          if (ref) {
            chartRefs[key] = ref;
          } else {
            delete chartRefs[key];
          }
        }}
      />
    </DataViewerFrame>
  );
};

ChangeByGniGroupChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  chooserId: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ChangeByGniGroupChartWidget;
